import PropTypes from 'prop-types';
import React from 'react';
import { CacheableSectionProvider } from './cacheable-section-state';
import { Dhis2ConnectionStatusProvider } from './dhis2-connection-status';
import { OfflineInterfaceProvider } from './offline-interface';
import { OnlineStatusMessageProvider } from './online-status-message';
/** A context provider for all the relevant offline contexts */
export function OfflineProvider(_ref) {
  let {
    offlineInterface,
    children
  } = _ref;
  // If an offline interface is not provided, or if one is provided and PWA
  // is not enabled, skip adding context providers
  if (!offlineInterface || !offlineInterface.pwaEnabled) {
    return /*#__PURE__*/React.createElement(React.Fragment, null, children);
  }
  return /*#__PURE__*/React.createElement(OfflineInterfaceProvider, {
    offlineInterface: offlineInterface
  }, /*#__PURE__*/React.createElement(Dhis2ConnectionStatusProvider, null, /*#__PURE__*/React.createElement(CacheableSectionProvider, null, /*#__PURE__*/React.createElement(OnlineStatusMessageProvider, null, children))));
}
OfflineProvider.propTypes = {
  children: PropTypes.node,
  offlineInterface: PropTypes.shape({
    pwaEnabled: PropTypes.bool
  })
};